module.exports = __webpack_public_path__ + "img/pro_jinniao_05.e989b99b.png";